<template>
  <div>
    <b-row>
      <!-- begin create card -->
      <b-col
        v-for="(choice, choiceKey) in choices"
        :key="choiceKey"
        cols="12"
        sm="6"
        lg="4"
        class="mb-4"
      >
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col md="6">
              <img :src="choice.image" class="img-fluid card-image rounded-0" />
            </b-col>
            <b-col md="6">
              <b-card-body>
                <b-card-title>Create new event</b-card-title>

                <b-card-text class="mt-2">
                  <url-button
                    class="btn-yellow"
                    :label="choice.text"
                    :url="choice.slug"
                  />
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- end create card -->
    </b-row>
  </div>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'
export default {
  components: {
    UrlButton
  },
  computed: {
    choices() {
      return [
        {
          text: 'Create new event from scratch',
          slug: '/event/new',
          image: require('@/assets/images/25.png')
        },
        {
          text: 'Create new event from template',
          slug: '/event/new/fromTemplate?t=s',
          image: require('@/assets/images/26.png')
        },
        {
          text: 'Create new event from existing event',
          slug: '/event/new/fromTemplate?t=e',
          image: require('@/assets/images/27.png')
        }
      ]
    }
  }
}
</script>
